// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface SortIconSignature {
  Element: SVGSVGElement;
}

export const SortIcon: TOC<SortIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.58501L18.707 8.29201L17.293 9.70601L12 4.41301L6.70703 9.70601L5.29303 8.29201L12 1.58501ZM12 19.585L17.293 14.292L18.707 15.706L12 22.413L5.29303 15.706L6.70703 14.292L12 19.585Z"/>
</svg>
</template>;